import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export const useRouteTracking = (
  onRouteChange: () => void,
  enabled: boolean,
) => {
  const location = useLocation();
  const onRouteChangeRef = useRef(onRouteChange);
  const isFirstRender = useRef(true);

  // Keep callback fresh
  useEffect(() => {
    onRouteChangeRef.current = onRouteChange;
  }, [onRouteChange]);

  useEffect(() => {
    // Skip tracking on initial mount (already handled by initialization)
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (enabled && onRouteChangeRef.current) {
      onRouteChangeRef.current();
    }
  }, [location.pathname, enabled]);
};
